import { render, staticRenderFns } from "./HeatmapOnly.vue?vue&type=template&id=01073872&scoped=true"
import script from "./HeatmapOnly.vue?vue&type=script&lang=js"
export * from "./HeatmapOnly.vue?vue&type=script&lang=js"
import style0 from "./HeatmapOnly.vue?vue&type=style&index=0&id=01073872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01073872",
  null
  
)

export default component.exports